import { applyOverrides, buildClientCard } from '../../shared';

const baseSellerCard = buildClientCard({
  id: 'sellerSideContacts.sellerX',
  entityType: 'counterpartyClient',
  label: 'Seller',
  showSameAsProperty: true,
});

export const sellerCard = applyOverrides(baseSellerCard, {
  fields: {
    firstName: {
      validation: [{ type: 'required', message: 'Required' }],
    },
  },
});
